import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { WEB_APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

// expense - Get All (Read)
export const GetAll = createAsyncThunk(
    "masters/expense/get-all",
    async (filter, { rejectWithValue }) => {
        try {
            const res = await GET(
                `${WEB_APIS.Masters.Expense}?name=${filter?.name || ""}&page=${filter?.page || IDS.PAGE
                }&endDate=${filter?.endDate || ''}&startDate=${filter?.startDate || ''}&per_page=${filter?.per_page || IDS.PERPAGE}&stock_filter=${filter?.filter || ""}&sort_by=${filter?.sortBy || ""}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// expense - Get (Read)
export const GetSingle = createAsyncThunk(
    "masters/expense/get",
    async (id, { rejectWithValue }) => {
        try {
            const res = await GET(`${WEB_APIS.Masters.Expense}/${id}`);
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const GetexpenseTransactions = createAsyncThunk(
    "masters/expense/get-ts",
    async ({ id, filter }, { rejectWithValue }) => {
        try {
            const res = await GET(`${WEB_APIS.Masters.Expense}/transactions/${id}?name=${filter?.name || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}&filter=${filter?.filter || ""}&sortBy=${filter?.sortBy || ""}`);
            return res?.data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// expense - Create (Add)
export const Create = createAsyncThunk(
    "masters/expense/create",
    async (data, { rejectWithValue }) => {
        try {
            const res = await POST(WEB_APIS.Masters.Expense, data);

            if (res.success) {

                return res; // The new expense object
            }

        } catch (error) {

            return rejectWithValue(error.response.data);
        }
    }
);

// expense - Update
export const Update = createAsyncThunk(
    "masters/expense/update",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const res = await PUT(`${WEB_APIS.Masters.Expense}/${id}`, data);
            return res;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

// expense - Delete
export const Delete = createAsyncThunk(
    "masters/expense/delete",
    async (id, { rejectWithValue }) => {
        try {
            const data = await DELETE(`${WEB_APIS.Masters.Expense}/${id}`);
            return id; // Return the id of the deleted expense
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// expense - Status
export const Status = createAsyncThunk(
    "masters/expense/status",
    async (id, { rejectWithValue }) => {
        try {
            const res = await POST(`${WEB_APIS.Masters.Expense}/${id}`);
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const AddStock = createAsyncThunk(
    "masters/expense/add-stock",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const res = await POST(`${WEB_APIS.Masters.Expense}/add-stock/${id}`, data);
            return res;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);
export const ReduceStock = createAsyncThunk(
    "masters/expense/reduce-stock",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const res = await POST(`${WEB_APIS.Masters.Expense}/reduce-stock/${id}`, data);
            return res;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const Slice = createSlice({
    name: "expense",
    initialState: {
        data: [],
        current_page: IDS.PAGE,
        total_pages: IDS.TOTALPAGES,
        per_page: IDS.PERPAGE,
        total: IDS.TOTAL,
        status: IDS.SLICESTATUS.Idle,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Handling all actions for GetSingle, Create, Update, Delete
            .addCase(GetAll.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetAll.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                state.data = action.payload?.data?.data || [];
                state.current_page = action.payload?.data?.current_page || IDS.PAGE;
                state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
                state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
                state.total = action.payload?.data?.total || IDS.TOTAL;
            })
            .addCase(GetAll.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            // .addCase(GetexpenseTransactions.pending, (state) => {
            //     state.status = IDS.SLICESTATUS.Loading;
            // })
            // .addCase(GetexpenseTransactions.fulfilled, (state, action) => {
            //     state.status = IDS.SLICESTATUS.Succeeded;
            //     state.transactions = action.payload?.data || [];
            //     state.current_page = action.payload?.current_page || IDS.PAGE;
            //     state.total_pages = action.payload?.total_pages || IDS.TOTALPAGES;
            //     state.per_page = action.payload?.per_page || IDS.PERPAGE;
            //     state.total = action.payload?.total || IDS.TOTAL;
            // })
            // .addCase(GetexpenseTransactions.rejected, (state, action) => {
            //     state.status = IDS.SLICESTATUS.Failed;
            //     state.error = action.payload;
            // })

            .addCase(GetSingle.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetSingle.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
            })
            .addCase(GetSingle.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(Create.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(Create.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                state.data.unshift(action.payload.data);
            })
            .addCase(Create.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(Update.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(Update.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                const index = state.data.findIndex(
                    (expense) => expense.id === action.payload?.data?.id
                );
                if (index !== -1) {
                    state.data[index] = action.payload.data;
                }
            })
            .addCase(Update.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(Delete.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(Delete.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                state.data = state.data.filter(
                    (expense) => expense.id !== action.payload.id
                ); // Remove the expense with the deleted id
            })
            .addCase(Delete.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })
            //
            .addCase(Status.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(Status.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                state.data = state.data.filter(
                    (expense) => expense.id !== action.payload.id
                ); // Remove the expense with the deleted id
            })
            .addCase(Status.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            });
    },
});

// Export actions (if needed in components)
export const { } = Slice.actions;

export default Slice.reducer;
